@if (preset() && !allowDelete()) {
  <a class="list-group-item list-group-item-action py-0 d-flex align-items-center"
     [routerLink]="[preset()?.id]">
    <div class="flex-fill">
      {{ getDisplayValue() }}
    </div>
  </a>

  <!-- Inline editable list item -->
} @else if (allowDelete()) {
  <div class="list-group-item py-0 d-flex align-items-center">
    <div class="flex-fill">
      <div class="row g-0 align-items-center">
        <span class="col">{{ getDisplayValue() }}</span>
        <span class="col-auto">
          <button type="button"
                  class="btn btn-sm btn-outline-danger border-0"
                  (click)="delete()">
            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
          </button>
        </span>
      </div>
    </div>
  </div>
}